import React, { useEffect, useState } from 'react';
import lodash from 'lodash';
import PropTypes from 'prop-types';

const withUseEffectErrorMessage = (InputComponent) => {
   const InnerWithUseEffectErrorMessage = (props) => {
      const [errorMessage, setErrorMessage] = useState();

      useEffect(() => {
         // Used for getting the errorMessage when NumberInput component is used as a FieldArray Field
         const nameParts = props.field.name.split(/\]\.|\.|\[|\]/);
         let errorPtr = props.form.errors;

         if (errorPtr) {
            for (let i = 0; i < nameParts.length; i++) {
               const name = nameParts[i];
               if (lodash.isObject(errorPtr)) {
                  errorPtr = errorPtr[name];
               } else {
                  break;
               }
            }
         }

         if (typeof errorPtr === 'string' || typeof errorPtr === 'undefined') {
            setErrorMessage(errorPtr);
         }
      }, [JSON.stringify(props.form.errors)]);

      return (
         <InputComponent
            {...props}
            errorMessage={errorMessage}
         />
      );
   };

   InnerWithUseEffectErrorMessage.propTypes = {
      field: PropTypes.shape({
         name: PropTypes.string.isRequired,
      }).isRequired,
      form: PropTypes.shape({
         errors: PropTypes.objectOf(PropTypes.any).isRequired,
      }).isRequired,
   };

   return InnerWithUseEffectErrorMessage;
};

export default withUseEffectErrorMessage;
